import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiChangeToTheSpecifiedEkycResultRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getIdentityVerifications = async (
  instance: AxiosInstance,
  organizationId: string
) => {
  return await userApiDefaultApiFactory(instance).getIdentityVerifications({
    organizationId,
  })
}

export const getIdentityVerificationsLatest = async (
  instance: AxiosInstance,
  organizationId: string
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getIdentifyVerificationsLatest({
    organizationId,
  })
}

export const changeToTheSpecifiedEkycResult = async (
  instance: AxiosInstance,
  params: DefaultApiChangeToTheSpecifiedEkycResultRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).changeToTheSpecifiedEkycResult(params)
}

// Do Not Remove this line ===@import api client===
